import { render } from "./inputResponse.vue?vue&type=template&id=3f8c0eb8&scoped=true"
import script from "./inputResponse.vue?vue&type=script&lang=js"
export * from "./inputResponse.vue?vue&type=script&lang=js"

import "./inputResponse.vue?vue&type=style&index=0&id=3f8c0eb8&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8c0eb8"]])

export default __exports__